import React, { Dispatch, SetStateAction } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { generateResponsiveStyle } from "../utils/modalStyle";
import moment from "moment";
import { formattedDescriptionText } from "../utils/validation";

type props = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    details: string;
};

const NotificationMessage = ({ open, setOpen, details }: props) => {
    const style = generateResponsiveStyle();

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="modal_title">
                    <Typography id="modal-modal-title" component="h2">Notification Message</Typography>
                    <CloseIcon className="cross_icn_logout" onClick={() => setOpen(false)} />
                </div>
                <div className="modal_body">
                    <div className="control_group">
                        <div className="msg_box">
                            <Typography
                                component="p"
                                dangerouslySetInnerHTML={{
                                    __html: formattedDescriptionText(details),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default NotificationMessage;
